import React from 'react';
import moment from 'moment';
import { inject, observer } from "mobx-react/index"
import { inventoryProduct } from "../../../../actions/api";
import { BASE_URL } from "../../../../config";

@inject('ticketStore', 'userStore', 'inventoryItemStore', 'inventoryProductStore')
@observer
export default class Log extends React.Component {

  imageExtensions = ['jpg', 'jpeg', 'png', 'svg', 'bmp', 'gif'];

  renderAttachment = file => {
    let extension = file.split('.')[1].toLowerCase(),
      src = BASE_URL + '/mms-files' + file,
      fileName = file.split('/')[3];

    if (this.imageExtensions.indexOf(extension) > -1) {
      return (
        <div className='log-attachment'>
          <a href={src} target='_blank'>
            <img height={60} width={60} src={src} alt={fileName} />
          </a>
        </div>
      );
    } else {
      return (
        <div className='log-attachment'>
          <a href={src} target='_blank'>
            <i className='fa fa-file-image-o' />
            <p>{fileName}</p>
          </a>
        </div>
      )
    }
  };

  render() {
    const { logs, date, userStore, inventoryItemStore, inventoryProductStore } = this.props;
    // console.log(log)


    return (
      <div className='log-item'>
        <div className='flex flex-row space-around log-item-seperator'>
          <p>{moment(date).format('MMM D, YYYY')}</p>
        </div>
        {logs.sort((a, b) => (new Date(a.log_date)).valueOf() < (new Date(b.log_date)).valueOf() ? 1 : -1).map((log) => {
          let assignedTo = userStore.findById(log.assigned_to),
            inventoryItem = inventoryItemStore.findById(log.item_id),
            inventoryProduct = inventoryItem && inventoryProductStore.findById(inventoryItem.product_id);
          return <div key={`work_order_log_${log.log_date}`} className='log'>
            <div className='flex-grow'>
              <div className='log-item-info'>
                <strong>{log.name}</strong>
                <span color='light-gray'>-  {moment(log.log_date).format(' hh:mm A')}</span>
              </div>
              <div className='log-item-body'>
                {log.text.split('\n').map((line, i) => (
                  <p key={`ticket-log-${log.id}-${i}`}>{line}</p>
                ))}
              </div>
              {(assignedTo || inventoryProduct || inventoryItem || log.actual_man_hours) ?
                <div className='log-item-footer'>
                  <div>{assignedTo && <p><b>Assigned to </b> : {assignedTo.name}</p>}</div>
                  <div>{inventoryProduct && inventoryItem && <div><p><b>Item</b> : {inventoryProduct.pcategory_name} - {inventoryItem.serial_no}</p></div>}</div>
                  <div>{log.actual_man_hours ? <p><b>Actual Man Hours</b> : {log.actual_man_hours}</p> : null}</div>
                </div> : null}
            </div>
            <div>
              {log.attachment_file && this.renderAttachment(log.attachment_file)}
            </div>
            <br />
          </div>
        })}
      </div>
    );

    // return (
    //   <div className='log-item'>
    //     <div className='flex flex-row space-around log-item-seperator'>
    //       <p>{moment(log.log_date).format('llll')}</p>
    //     </div>
    //     <div className='log-item-info'>{createdBy && createdBy.name}</div>
    //     <div className='log-item-body'>
    //       <p>{log.text}</p>
    //       {log.attachment_file && this.renderAttachment(log.attachment_file)}
    //     </div>
    //     <div className='log-item-footer'>
    //       <p><b>Assigned to </b> : {assignedTo && assignedTo.name}</p>
    //       <p>{inventoryProduct && inventoryItem && <div><b>Item</b> : {inventoryProduct.pcategory_name} - {inventoryItem.serial_no}</div>}</p>
    //       <p><b>Actual Man Hours</b> : {log.actual_man_hours}</p>
    //     </div>
    //   </div>
    // );
  }
}


// WEBPACK FOOTER //
// ./src/components/Maintenance/WorkOrder/Log/Log.js